export default __webpack_public_path__ + "static/media/brian.27f0fa01.jpg";